export const SET_SEARCH_ACTIVE = "search/SET_SEARCH_ACTIVE"
export const SET_FINISHED_INPUTTING_SYMPTOMS =
  "search/SET_FINISHED_INPUTTING_SYMPTOMS"
export const SET_SUGGESTION_LOADING = "search/SET_SUGGESTION_LOADING"
export const SET_SEARCH_ATTEMPTED = "search/SET_SEARCH_ATTEMPTED"
export const SET_SEARCH_SUGGESTIONS = "search/SET_SEARCH_SUGGESTIONS"
export const SET_SEARCH_RESULTS = "search/SET_SEARCH_RESULTS"
export const SET_SEARCH_MSG = "search/SET_SEARCH_MSG"
export const SET_SEARCH = "search/SET_SEARCH"
export const SET_CACHED_SEARCH = "search/SET_CACHED_SEARCH"
export const SET_HEADER = "search/SET_HEADER"
export const SET_ITEM_TEXT = "search/SET_ITEM_TEXT"
export const SET_ITEM_FINISHED = "search/SET_ITEM_FINISHED"
export const SET_CACHED_HEADER = "search/SET_CACHED_HEADER"
export const INCREMENT_AUTOSUGGEST_SEQUENCE =
  "search/INCREMENT_AUTOSUGGEST_SEQUENCE"
export const INCREMENT_SUGGESTION = "search/INCREMENT_SUGGESTION"
export const DECREMENT_SUGGESTION = "search/DECREMENT_SUGGESTION"
export const SET_SUBMITTED = "search/SET_SUBMITTED"
export const SET_USER_INTENT = "interview/SET_USER_INTENT"
export const SET_USER_INTENT_CARE_OPTION =
  "interview/SET_USER_INTENT_CARE_OPTION"



// WEBPACK FOOTER //
// ./assets/search/actionTypes.js